import { render, staticRenderFns } from "./rating-card.vue?vue&type=template&id=a7accc84&scoped=true&"
import script from "./rating-card.vue?vue&type=script&lang=js&"
export * from "./rating-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7accc84",
  null
  
)

export default component.exports